const context : {
  iframeMouseOver: boolean,
  node: HTMLElement | undefined
} = {iframeMouseOver: false, node: undefined};

function mouseEnter() {
  context.iframeMouseOver = true;
}
function mouseLeave() {
  context.iframeMouseOver = false;
  window.focus();
}

export function blurHappened() {
  document.addEventListener('click', returnFocus);
  if (document.activeElement !== context.node && !context.iframeMouseOver)
    document.body.style.filter = 'blur(10px)';
  else
    document.body.style.filter = '';
}

function returnFocus() {
  document.body.style.filter = '';
  document.removeEventListener('click', returnFocus);
}

export function enableBlurProtection(node?:HTMLElement, iframeMouseOver?: boolean) {
  if (node && iframeMouseOver !== undefined) {
    context.node = node;
    context.iframeMouseOver=iframeMouseOver;
    if (context.node) {
      context.node.addEventListener('mouseover', mouseEnter);
      context.node.addEventListener('mouseout', mouseLeave);
    }
  }
  window.addEventListener('blur', blurHappened);
}

export function disableBlurProtection() {
  context.node = undefined;
  context.iframeMouseOver=false;
  returnFocus();
  window.removeEventListener('blur', blurHappened);
}
